<ngx-ui-loader></ngx-ui-loader>
<router-outlet><app-spinner></app-spinner></router-outlet>

